module.exports = __webpack_public_path__ + "img/bg-desktop.df05551a.jpg";